export const painPoints = [
  {
    emoji: '🧭',
    title: 'Sie wissen nicht, wo Sie anfangen sollen',
    desc: 'Der Rehabilitationsprozess wirkt unmöglich und Sie fühlen sich von der Fülle überfordert. DER REHA-CODE 360° ordnet alles: erst die Beurteilung, dann die akute Phase, dann progressive Stärkung, dann Return-to-Sport.',
  },
  {
    emoji: '🔤',
    title: 'Sie stecken bei der Übungsauswahl fest (und alles sieht gleich aus)',
    desc: 'Sie lernen hier den geführten Weg mit dem Traffic Light System, damit Sie Progressionsmuster erkennen und mit Absicht verschreiben. Keine Verwirrung mehr zwischen ähnlichen Übungen und ihren Progressionen.',
  },
  {
    emoji: '🧩',
    title: 'Sie kennen einzelne Übungen, aber können kein komplettes Protokoll bauen',
    desc: 'Sie lernen die komplette Phasenstruktur, um Protokolle zu bauen, die wirklich Sinn ergeben und Klienten vom ersten Tag an in echte Heilung starten.',
  },
  {
    emoji: '💭',
    title: 'Sie verschreiben, aber vergessen die Progressionskriterien',
    desc: 'Sie erhalten konkrete Beurteilungs-Checkpoints und Fortschritts-Richtlinien mit dem Load Master Protocol, damit das, was Sie verschreiben, wirklich vorangeht.',
  },
  {
    emoji: '🎯',
    title: 'Sie betreuen Klienten, aber fürchten eine erneute Verletzung',
    desc: 'Raten ist gefährlich. Das A.R.M.A. Schild und sein wöchentliches Wartungssystem halten Athleten sicher und selbstvertrauend bis zur vollständigen Rückkehr.',
  },
  {
    emoji: '🔁',
    title: 'Sie haben einen Kurs gestartet und nach zwei Wochen abgebrochen',
    desc: 'Einzelne Lektionen sind kein Fortschritt. Ein komplettes 6-Band-System mit sichtbaren Meilensteinen hält Sie in Schwung.',
  },
];
